import { Component, Input, signal, WritableSignal, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MyConfigOrganization } from '../../../../../models/myConfig';
import { OrganizationAdditionalServiceVM } from '../../../../../models/orderModel';
import { AdditionalServicesFormComponent } from '../additional-services-form/additional-services-form.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';

@Component({
  selector: 'app-additional-services-list',
  standalone: false,
  templateUrl: './additional-services-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './additional-services-list.component.css'
})

export class AdditionalServicesListComponent {
  @ViewChild(MatSort) sort: MatSort;
  dataSource = new MatTableDataSource<OrganizationAdditionalServiceVM>([]);
  additionalServices: WritableSignal<OrganizationAdditionalServiceVM[]> = signal([]);
  emptyData = new MatTableDataSource([{ empty: "row" }]);

  @Input() set additionalServicesInput(value: OrganizationAdditionalServiceVM[]) {
    if (value) {
      this.additionalServices.set(value);
      this.dataSource.data = value;
    }
  }

  loading: boolean;
  @Input() organization: MyConfigOrganization;
  displayedColumnsAdditionalServices: string[] = [
    // "id",
    "name",
    "description",
    // "productId",
    "productCode",
    "availability",
    "performingOrganizationName",
    "minimumStay",
    "typeName",
    // "price",
    // "vat",
    // "vatPercentage",
    "totalPrice",
    "statusName",
    // "discountAmount",
    // "discountVatAmount",
    // "discountTotalPrice",
    // "discountCheckPercent",
    // "discountCheckAmount",
    // "performingOrganizationName"
  ];

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'name': return item.name || '';
        case 'description': return item.description || '';
        case 'typeName': return item.typeName || '';
        case 'statusName': return item.statusName || '';
        default: return item[property];
      }
    };
  }

  constructor(
    public dialog: MatDialog,
  ) { }

  getStatusColor(status) {
    switch (status) {
      case "Active":
        return '#28a745';
      case "Expired":
        return "#dc3545";
      default:
        return '#ffc107';
    }
  }

  ngOnInit(): void {
    // console.log(this.additionalServices);
    // this.additionalServices.set([]);
  }

  ngOnChanges() {
  }

  openEditAdditionalServiceModal(additionalService?: any) {
    if (this.additionalServices()?.length > 0) {
      var model: any = additionalService ? additionalService : null;

      const dialogRef = this.dialog.open(AdditionalServicesFormComponent, {
        // height: '1010px',
        // minHeight: '80vh',
        width: '720px',
        hasBackdrop: true,
        data: {
          additionalService: model,
          organization: this.organization,
          edit: model ? true : false,
        }
      });

      dialogRef.afterOpened().subscribe(() => {
        const componentInstance = dialogRef.componentInstance as AdditionalServicesFormComponent;
        componentInstance.saveChangesEvent.subscribe((additionalService) => {
          this.updateAdditionalServices(additionalService);
        });
      });
    }
  }

  updateAdditionalServices(additionalService) {
    const currentData = this.dataSource.data;
    const index = currentData.findIndex(dc => dc.id === additionalService.id);

    if (index > -1) {
      const updatedData = [...currentData];
      updatedData[index] = additionalService;
      this.dataSource.data = updatedData;
    } else {
      this.dataSource.data = [additionalService, ...currentData];
    }
    this.additionalServices.set(this.dataSource.data);
  }
}
